import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "waveBox" }
const _hoisted_2 = { class: "innerPeak" }
const _hoisted_3 = ["id"]
const _hoisted_4 = ["width"]
const _hoisted_5 = { class: "scroll-content" }
const _hoisted_6 = ["onMouseover", "onMousedown"]
const _hoisted_7 = ["onMousedown"]
const _hoisted_8 = ["onMousedown"]
const _hoisted_9 = { class: "toolBox" }
const _hoisted_10 = { class: "toolBoxLeft" }
const _hoisted_11 = { class: "toolBoxpointBox" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "toolBoxRight" }
const _hoisted_14 = { class: "toolBoxRightBox" }

import { onMounted, nextTick, ref, watch,computed } from "vue";
import newCaptionApi from "@/api/newCaption/index.ts";
import { carveTimeScale } from './timeLine.js'
import { carveWave } from './wave.js'
import { ElScrollbar } from 'element-plus'
import { login } from "@/api/Login";
import { useRouter ,useRoute} from 'vue-router';
import { useRafFn } from '@vueuse/core'
import {captionTtsStore} from "@/store/captionTts.ts"

export default /*@__PURE__*/_defineComponent({
  __name: 'waveCanvas',
  props: {
    creatData: Object,
    runTime: Number,
    onOffplay: Boolean,
    times: Number,
},
  emits: ['dragtextTime', 'lnineToTime', 'finishPlay','textBoxMove','waveOldDataText'],
  setup(__props, { expose: __expose, emit: __emit }) {

const router = useRouter();
const route=useRoute()
// 引入store
const ttstore=captionTtsStore()
watch(route, (to, from) => {
    lineToLeft.value=0
    runLong.value=0
    scrollbarRef.value!.setScrollLeft(0)
    ttstore.toInit()
})
const textrightLine =ref(false)
const isOpen=ref(false)
const originalData=ref([])
const dubbingData=ref([])
const isTtsDubbing=ref(false)
// 监测TTS状态
watch(ttstore,(n,o)=>{
    console.log('监测TTS状态')
    console.log(n.ttsListData)
    isOpen.value=n.isOpen
    textrightLine.value=n.isHeightLight
    console.log(textrightLine.value) 
    isTtsDubbing.value=n.isDubbing   
    if(n.ttsListData.length>0){
        textBox.value=n.ttsListData
         textBox.value.forEach(item => {
            // let leftPonstions = (item.beginTime * 62.5 / 1000)
            // let rightPositions = (item.endTime * 62.5 / 1000)
            let leftPonstions = (item.beginTime * speedSpeak.value / 1000)
            let rightPositions = (item.endTime * speedSpeak.value / 1000)
            item.textWidth = (rightPositions - leftPonstions)
            item.floatLefts = leftPonstions
        })
    }
    console.log(textBox.value) 
})
const innerRef = ref<HTMLDivElement>()
const scrollbarRef = ref<InstanceType<typeof ElScrollbar>>()

const props = __props;
watch(() => props.creatData.id, (n, o) => {
    console.log(n)
    textBox.value=[]
    lineToLeft.value=0
    runLong.value=0
    timeBoxLeft.value=0
    scrollbarRef.value!.setScrollLeft(0)
    reText(n)
})
// 替换音轨字幕
const reText=(id:string)=>{
    // console.log('替换音轨字幕')
    newCaptionApi.getEditCaption(props.creatData.subtitleId,id).then(res => {
        // console.log('-------')
        // console.log(res.data)
        
        // boxWidth.value = (res.data[0].duration / 1000000 * 62.5)
        boxWidth.value = (props.creatData.duration / 1000 * speedSpeak.value)
        duration.value = props.creatData.duration*1
        textBox.value = res.data[0].subtitles
        if(textBox.value[0].original.text==undefined){
            textBox.value[0].original.text=''
        }
       
        translatShow.value = (textBox.value.filter(item => (item.translation!=undefined&&item.translation.text != undefined&&item.translation.text != ''))).length >0 ? true : false
        deltranslatShow.value = (textBox.value.filter(item =>(item.translation!=undefined&&item.translation.text != undefined&&item.translation.text != ''))).length >0 ? true : false
    //    console.log(deltranslatShow.value)
    //     console.log(translatShow.value)
        textBox.value.forEach(item => {
            // let leftPonstions = (item.beginTime * 62.5 / 1000)
            // let rightPositions = (item.endTime * 62.5 / 1000)
            let leftPonstions = (item.beginTime * speedSpeak.value / 1000)
            let rightPositions = (item.endTime * speedSpeak.value / 1000)
            item.textWidth = (rightPositions - leftPonstions)
            item.floatLefts = leftPonstions
        })
        timeCanvasNum.value = Math.ceil(boxWidth.value / 1500)
        setTimeout(() => {
            showTimeCanvas.value = true
            timeCanvasNum.value = Math.ceil(boxWidth.value / 1500)
            for (let i = 0; i < timeCanvasNum.value; i++) {
                // carveTimeScale(1500, 1, 62.5, i * 24000, 10, 'time_line' + i)
                carveTimeScale(1500, 1, speedSpeak.value, i * (1500 * 1000 / speedSpeak.value), 10, 'time_line' + i)
            }
            getwave.value = props.creatData.peaks
            carveWave(props.creatData.peaks, canvaswaveId, ctx, pointMovevalue.value)
        }, 100)
    })
}
// 音轨指针linemousedown
const oldLinepageX=ref(0)
const oldlineToLeft=ref(0)
const linemousedown=(e:any)=>{
    console.log(e)
    oldLinepageX.value=e.pageX
    oldlineToLeft.value=lineToLeft.value
    document.addEventListener('mousemove', linedrag);
    document.addEventListener('mouseup', linestopDrag);
}
const linedrag=(e:any)=>{
    console.log('线条')
    console.log(e.pageX-oldLinepageX.value)
    let lineOffset=(e.pageX-oldLinepageX.value)
    
    // 获取音轨显示区域宽度
    console.log(subtitlesRef.value.offsetWidth)
    if((oldlineToLeft.value+lineOffset)<=(subtitlesRef.value.offsetWidth)){
        lineToLeft.value=(oldlineToLeft.value+lineOffset)
    }
    const timeRun = (lineToLeft.value + timeFloatLeft.value) / speedSpeak.value
    runLong.value = (timeRun * speedSpeak.value)
    emit('lnineToTime', timeRun)
}
const linestopDrag=(e:any)=>{
    console.log('停止')
    document.removeEventListener('mousemove', linedrag)
}
// 字幕拉伸
const pointList = [
    { index: 0, blockSize: 32, speedSpeak: 500 },
    { index: 1, blockSize: 64, speedSpeak: 250 },
    { index: 2, blockSize: 128, speedSpeak: 125 },
    { index: 3, blockSize: 256, speedSpeak: 62.5 },
    { index: 4, blockSize: 512, speedSpeak: 31.25 },
    { index: 5, blockSize: 1024, speedSpeak: 15.625 },
    { index: 6, blockSize: 2048, speedSpeak: 7.8125 },

]
// 采样率为256时速率
const speedSpeak = ref(62.5)
const speedLevel = ref(3)
const blockSizenum = ref(256)
const multiple = ref(1)
const peakPointStyle = {
    'background': '#62676A'
}
const peakPoint = (index: number, blockSize: number) => {
    console.log(index)
    console.log(blockSize)
    if (index == speedLevel.value) {
        return
    }

    const speedOne = pointList.filter(item => item.index == index)[0]
    speedLevel.value = index
    multiple.value = 256 / speedOne.blockSize
    speedSpeak.value = 62.5 * multiple.value
    blockSizenum.value = speedOne.blockSize
    boxWidth.value = (duration.value / 1000 * speedSpeak.value)
    timeCanvasNum.value = Math.ceil(boxWidth.value / 1500)
    console.log(timeCanvasNum.value)
    for (let i = 0; i < timeCanvasNum.value; i++) {
        carveTimeScale(1500, 1, speedSpeak.value, i * (1500 * 1000 / speedSpeak.value), 10, 'time_line' + i)
    }
    //
    textBox.value.forEach(item => {
        // let leftPonstions = (item.beginTime * 62.5 / 1000)
        // let rightPositions = (item.endTime * 62.5 / 1000)
        let leftPonstions = (item.beginTime * speedSpeak.value / 1000)
        let rightPositions = (item.endTime * speedSpeak.value / 1000)
        item.textWidth = (rightPositions - leftPonstions)
        item.floatLefts = leftPonstions
    })
    ctx.clearRect(0, -70, canvaswaveId.width, canvaswaveId.height)
    endTime.value = (((timeFloatLeft.value + subtitlesRef.value.offsetWidth) / speedSpeak.value) * 16000)

    newCaptionApi.getwave(props.creatData.subtitleId, blockSizenum.value, Math.ceil(startTime.value), Math.ceil(endTime.value)).then(res => {
        // console.log(props.creatData)
        getwave.value = res.data
        carveWave(res.data, canvaswaveId, ctx, pointMovevalue.value)

    })

}
// 字幕缩放
const pointMovevalue = ref(40)
const getwave = ref()
const pointChange = (e) => {
    // console.log(e)
    pointMovevalue.value = e
    nextTick(() => {
        carveWave(getwave.value, canvaswaveId, ctx, pointMovevalue.value)
    })

}



const lineToLeft = ref(0)
const runLong = ref(0)
let setIntervalTime = null
const timeBoxLeft = ref(0)


// 提取位置更新逻辑为单独的函数
function updatePosition(contentWidth, num) {
    if (runLong.value < boxWidth.value && runLong.value < contentWidth * num) {
        lineToLeft.value = ((runLong.value % contentWidth))
        timeBoxLeft.value = Math.floor(runLong.value / contentWidth) * contentWidth
        scrollbarRef.value!.setScrollLeft(timeBoxLeft.value)
    } else if (runLong.value < boxWidth.value && runLong.value >= contentWidth * num) {
        if (num < 1) {
            lineToLeft.value = runLong.value
            timeBoxLeft.value = 0
            scrollbarRef.value!.setScrollLeft(0)
        } else {
            lineToLeft.value = (contentWidth * num - (boxWidth.value - contentWidth)) + (runLong.value - contentWidth * num)
            timeBoxLeft.value = boxWidth.value - contentWidth
            scrollbarRef.value!.setScrollLeft(boxWidth.value - contentWidth)
        }
    }
}
watch(() => props.times, (n, o) => {

    // runLong.value = n * 62.5
    if (n > o) {
        // console.log(n)
        runLong.value = (n * speedSpeak.value)
        console.log('指针距离'+runLong.value)
        console.log('视频播放时间========'+n)

        // const contentWidth = subtitlesRef.value.offsetWidth
        // console.log('容器大小========'+contentWidth)
        // // lineToLeft.value = (((runLong.value *1)% contentWidth)).toFixed(2)
        // console.log('视频播放时间========'+lineToLeft.value)
    }

})
watch(() => props.onOffplay, (onoff) => {
    if (tofinish.value) {
        pause() // 先暂停动画
        runLong.value = 0
        lineToLeft.value = 0
        timeBoxLeft.value = 0
        scrollbarRef.value!.setScrollLeft(0)
        tofinish.value = false
    }
    
    const contentWidth = subtitlesRef.value.offsetWidth
    const num = Math.floor(boxWidth.value / contentWidth)
    
    if (onoff) {
        // 播放时恢复动画
        resume()
    } else {
        // 暂停时停止动画
        pause()
        
        // 暂停时也要更新一次位置
        updatePosition(contentWidth, num)
        
        // 检查是否结束
        if (runLong.value >= boxWidth.value) {
            lineToLeft.value = contentWidth
            tofinishPlay()
        }
    }
}, { immediate: false })

// 使用 useRafFn 创建动画循环
const { pause, resume, isActive } = useRafFn(() => {
    // 计算时间增量，保持与原来速度一致
    const deltaTime = 100 // 使用固定的时间增量，因为原逻辑是基于100ms间隔的
    runLong.value += (speedSpeak.value / 100)
    
    // 容器宽度
    const contentWidth = subtitlesRef.value.offsetWidth
    // 容器倍数
    const num = Math.floor(boxWidth.value / contentWidth)
    
    updatePosition(contentWidth, num)
    
    // 检查是否结束
    if (runLong.value >= boxWidth.value) {
        pause()
        lineToLeft.value = contentWidth
        tofinishPlay()
    }
}, { immediate: false }) // 默认不立即执行


// watch(() => props.onOffplay, (onoff) => {
//     //  console.log(onoff)
//     //  console.log('进度时间'+(props.runTime/1000).toFixed(2))
//     //  const timeRun=(props.times/1000).toFixed(2)
//     //  lineToLeft.value=(timeRun*62.5).toFixed(2)
//     if (tofinish.value) {
//         runLong.value = 0
//         lineToLeft.value = 0
//         timeBoxLeft.value = 0
//         scrollbarRef.value!.setScrollLeft(0)
//         tofinish.value = false
//     }
//     const contentWidth = subtitlesRef.value.offsetWidth
//     const num = Math.floor(boxWidth.value / contentWidth)
//     // console.log('==========' + runLong.value)
//     // console.log('容器' + boxWidth.value)
//     if (onoff) {
//         setIntervalTime = setInterval(() => {
//             // runLong.value += 0.625
//             runLong.value += (speedSpeak.value / 10)
//             // console.log('标线位置'+runLong.value)
//             // 容器宽度
//             const contentWidth = subtitlesRef.value.offsetWidth
//             // 容器倍数


//             const num = Math.floor(boxWidth.value / contentWidth)
//             // console.log('容器倍数' + num)
//             // console.log((boxWidth.value / runLong.value))
//             if (runLong.value < boxWidth.value && runLong.value < contentWidth * num) {
//                 // console.log('contentWidth' + contentWidth)
//                 // console.log('runLong' + runLong.value)
//                 lineToLeft.value = ((runLong.value % contentWidth))
//                 // 时间轴偏移
//                 // timeBoxLeft.value = Math.floor(runLong.value / contentWidth) * contentWidth
//                 timeBoxLeft.value = Math.floor(runLong.value / contentWidth) * contentWidth
//                 // console.log('时间轴偏移' + timeBoxLeft.value)
//                 // 字幕框偏移
//                 // console.log(timeBoxLeft.value)
//                 // 滚动条位置
//                 scrollbarRef.value!.setScrollLeft(timeBoxLeft.value)
//             } else if (runLong.value < boxWidth.value && runLong.value >= contentWidth * num) {
//                 if (num < 1) {
//                     // 标线偏移量
//                     lineToLeft.value = runLong.value
//                     // 时间轴偏移
//                     timeBoxLeft.value = 0
//                     // 滚动条位置
//                     scrollbarRef.value!.setScrollLeft(0)

//                 } else {
//                     // 标线偏移量
//                     lineToLeft.value = (contentWidth * num - (boxWidth.value - contentWidth)) + (runLong.value - contentWidth * num)
//                     // 时间轴偏移
//                     timeBoxLeft.value = boxWidth.value - contentWidth
//                     // 滚动条位置
//                     scrollbarRef.value!.setScrollLeft(boxWidth.value - contentWidth)
//                 }

//                 // console.log('时间轴偏移1111'+ timeBoxLeft.value)
//             } else
//                 if (runLong.value >= boxWidth.value) {
//                     // console.log('结束了')
//                     clearInterval(setIntervalTime)
//                     // 标线偏移量
//                     lineToLeft.value = (contentWidth)
//                     setIntervalTime = null
//                     tofinishPlay()
//                     return
//                 }



//         }, 100)
//     } 
//     else {
//         // runLong.value = (props.times * speedSpeak.value)
//         if (runLong.value < boxWidth.value && runLong.value < contentWidth * num) {
                
//                 lineToLeft.value = ((runLong.value % contentWidth))
//                 timeBoxLeft.value = Math.floor(runLong.value / contentWidth) * contentWidth
//                 scrollbarRef.value!.setScrollLeft(timeBoxLeft.value)
//         }else if (runLong.value < boxWidth.value && runLong.value >= contentWidth * num) {
//                 if (num < 1) {
//                     // 标线偏移量
//                     lineToLeft.value = runLong.value
//                     // 时间轴偏移
//                     timeBoxLeft.value = 0
//                     // 滚动条位置
//                     scrollbarRef.value!.setScrollLeft(0)

//                 } else {
//                     // 标线偏移量
//                     lineToLeft.value = (contentWidth * num - (boxWidth.value - contentWidth)) + (runLong.value - contentWidth * num)
//                     // 时间轴偏移
//                     timeBoxLeft.value = boxWidth.value - contentWidth
//                     // 滚动条位置
//                     scrollbarRef.value!.setScrollLeft(boxWidth.value - contentWidth)
//                 }

//                 // console.log('时间轴偏移1111'+ timeBoxLeft.value)
//             } else
//                 if (runLong.value >= boxWidth.value) {
//                     clearInterval(setIntervalTime)
//                     // 标线偏移量
//                     lineToLeft.value = (contentWidth)
//                     setIntervalTime = null
//                     tofinishPlay()
//                     return
//                 }


//         clearInterval(setIntervalTime)
//         setIntervalTime = null
//     }

// });


const subtitlesRef = ref()
const textBox = ref([])//字幕信息
const timeNum = ref('')//音频时长
const boxWidth = ref(0)//容器宽度
const timeFloatLeft = ref(0)
const videoId = ref('1784918245422190594')
let canvaswaveId
let ctx
const boxCanvasWidth = ref(props.creatData.canvasWidth >= 2500 ? ref(props.creatData.canvasWidth) : ref(2500))
// const boxCanvasWidth=ref(props.creatData.canvasWidth)
// 检测音轨容器大小变化
onMounted(() => {
    console.log('检测音轨容器大小变化')
    console.log(props)
    window.addEventListener('resize', handleResize);

});
const handleResize = () => {
    // console.log('检测音轨容器大小变化'+subtitlesRef.value.offsetWidth)
    // const contentWidth = subtitlesRef.value.offsetWidth

    const obj = {
        scrollLeft: timeFloatLeft.value
    }
    scrollFu(obj)
}
const showTimeCanvas = ref(false)
const deltranslatShow = ref(false)
const duration = ref(0)
onMounted(() => {
    canvaswaveId = document.getElementById('wave')
    ctx = canvaswaveId.getContext('2d')

    ctx.translate(0, 70)
    // ctx.clearRect(0, -70, canvaswaveId.width, canvaswaveId.height)
    // 滚动条位置
    // scrollbarRef.value!.setScrollLeft(200)

    newCaptionApi.getEditCaption(props.creatData.subtitleId,props.creatData.id).then(res => {
        console.log('-------')
        console.log(res.data)
        
        // boxWidth.value = (res.data[0].duration / 1000000 * 62.5)
        boxWidth.value = (props.creatData.duration / 1000 * speedSpeak.value)
        duration.value = props.creatData.duration*1
        textBox.value = res.data[0].subtitles
        if(textBox.value[0].original.text==undefined){
            textBox.value[0].original.text=''
            }
       
        translatShow.value = (textBox.value.filter(item => (item.translation!=undefined&&item.translation.text != undefined&&item.translation.text != ''))).length >0 ? true : false
     deltranslatShow.value = (textBox.value.filter(item =>(item.translation!=undefined&&item.translation.text != undefined&&item.translation.text != ''))).length >0 ? true : false
      textBox.value.forEach(item => {
            // let leftPonstions = (item.beginTime * 62.5 / 1000)
            // let rightPositions = (item.endTime * 62.5 / 1000)
            let leftPonstions = (item.beginTime * speedSpeak.value / 1000)
            let rightPositions = (item.endTime * speedSpeak.value / 1000)
            item.textWidth = (rightPositions - leftPonstions)
            item.floatLefts = leftPonstions
        })
        timeCanvasNum.value = Math.ceil(boxWidth.value / 1500)
        setTimeout(() => {
            showTimeCanvas.value = true
            timeCanvasNum.value = Math.ceil(boxWidth.value / 1500)
            for (let i = 0; i < timeCanvasNum.value; i++) {
                // carveTimeScale(1500, 1, 62.5, i * 24000, 10, 'time_line' + i)
                carveTimeScale(1500, 1, speedSpeak.value, i * (1500 * 1000 / speedSpeak.value), 10, 'time_line' + i)
            }
            getwave.value = props.creatData.peaks
            carveWave(props.creatData.peaks, canvaswaveId, ctx, pointMovevalue.value)
        }, 100)
    })
})
const canvasBoxRef = ref()
const timeCanvasNum = ref(1)

// 
const isScrolling = ref(false);
let scrollTimeout = null;
const startTime = ref(0)
const endTime = ref(0)
const contentRef = ref()
const scrollFu = (e) => {
    // console.log(e)
    // console.log(e.scrollLeft)
    // console.log('宽度---------'+subtitlesRef.value.offsetWidth)
    timeFloatLeft.value = e.scrollLeft
    timeBoxLeft.value = e.scrollLeft
    lineToLeft.value = (runLong.value - e.scrollLeft)
    //  console.log(lineToLeft.value)
    //  console.log(runLong.value)

    /*
        samplesPerPixel:256//采样率
        startSample：开始时间*16000
        endSample：结束时间*16000
        每秒运行62.5px
    */
    // let startTime
    // let width = (subtitlesRef.value.offsetWidth >= 1500) ? subtitlesRef.value.offsetWidth : 1500;
    //  console.log('宽度---------'+width)
    // endTime.value = (((e.scrollLeft + subtitlesRef.value.offsetWidth) / 62.5) * 16000)
    // e.scrollLeft == 0 ? startTime.value = 1 : startTime.value = ((e.scrollLeft / 62.5) * 16000)
    endTime.value = (((e.scrollLeft + subtitlesRef.value.offsetWidth) / speedSpeak.value) * 16000)
    e.scrollLeft == 0 ? startTime.value = 1 : startTime.value = ((e.scrollLeft / speedSpeak.value) * 16000)
    ctx.clearRect(0, -70, canvaswaveId.width, canvaswaveId.height)
    if (!isScrolling.value) {
        isScrolling.value = true;
        // console.log('=========')
        // console.log(scrollTimeout)
        clearTimeout(scrollTimeout);
        scrollTimeout = null
        // ctx.clearRect(0, -70, canvaswaveId.width, canvaswaveId.height)
        scrollTimeout = setTimeout(() => {
            // console.log('开始帧')
            // console.log(startTime.value)
            // 滚动停止后执行的操作，如请求数据
            newCaptionApi.getwave(props.creatData.subtitleId, blockSizenum.value, Math.ceil(startTime.value), Math.ceil(endTime.value)).then(res => {
                // console.log(res.data)
                getwave.value = res.data
                carveWave(res.data, canvaswaveId, ctx, pointMovevalue.value)
                isScrolling.value = false;
            })

        }, 1000); // 1000毫秒的延迟来判断用户是否停止滚动
    }

}
const boxIndex = ref(-1)
// 鼠标点击拖拽字幕
const x = ref(0)//初始化X轴位置
const oldLeft = ref(0)//原来字幕框位置
const textFunType = ref('')//字幕点击类型
const textMouse = (e, index, type) => {
    // console.log('点击' + e.pageX)
    // console.log('点击index' + index)
    textFunType.value = type
    boxIndex.value = index
    // console.log(boxIndex.value)
    oldLeft.value = contentRef.value.getElementsByClassName('itemBox')[index].style.left.split('px')[0]

    let elementThis = contentRef.value.getElementsByClassName('itemBox')[index]
    x.value = e.pageX
    mouseupBox('DataOld','',boxIndex.value)
    
    document.addEventListener('mousemove', drag);
    document.addEventListener('mouseup', stopDrag);
    
    
}
const drag = (e) => {
    textOverOnOff.value=true
    console.log('字幕框Index' + boxIndex.value)
    if (textFunType.value == 'textBox') {//字幕框拖拽位移
       
       
        let left = e.pageX - x.value
        // console.log('偏移量' + left)
        const offsetLeft = (oldLeft.value * 1 + left * 1)
        const thisWidth = contentRef.value.getElementsByClassName('itemBox')[boxIndex.value].style.width.split('px')[0]
        if (boxIndex.value == 0) {
            contentRef.value.getElementsByClassName('itemBox')[boxIndex.value].style.left = (oldLeft.value * 1 + left * 1) + 'px'
            const rightBox = contentRef.value.getElementsByClassName('itemBox')[boxIndex.value + 1].style.left.split('px')[0]//右侧字幕box
            // console.log(rightBox - thisWidth)
            if (offsetLeft < 0) {
                // offsetLeft=0
                contentRef.value.getElementsByClassName('itemBox')[boxIndex.value].style.left = 0 + 'px'
            } else if ((rightBox - offsetLeft) < thisWidth) {
                contentRef.value.getElementsByClassName('itemBox')[boxIndex.value].style.left = (rightBox - thisWidth) + 'px'
            }
        } else if (boxIndex.value > 0 && boxIndex.value < (textBox.value.length - 1)) {
            contentRef.value.getElementsByClassName('itemBox')[boxIndex.value].style.left = (oldLeft.value * 1 + left * 1) + 'px'
            const leftBox = contentRef.value.getElementsByClassName('itemBox')[boxIndex.value - 1].style.left.split('px')[0]//左侧字幕box
            const leftWidth = contentRef.value.getElementsByClassName('itemBox')[boxIndex.value - 1].style.width.split('px')[0]
            const rightBox = contentRef.value.getElementsByClassName('itemBox')[boxIndex.value + 1].style.left.split('px')[0]//右侧字幕box
            if (offsetLeft < (leftBox * 1 + leftWidth * 1)) {
                contentRef.value.getElementsByClassName('itemBox')[boxIndex.value].style.left = (leftBox * 1 + leftWidth * 1) + 'px'
            }
            else if ((rightBox - offsetLeft) < thisWidth) {
                contentRef.value.getElementsByClassName('itemBox')[boxIndex.value].style.left = (rightBox - thisWidth) + 'px'
            } else {
                contentRef.value.getElementsByClassName('itemBox')[boxIndex.value].style.left = (oldLeft.value * 1 + left * 1) + 'px'
            }
        } else if (boxIndex.value == (textBox.value.length - 1)) {
            const leftBox = contentRef.value.getElementsByClassName('itemBox')[boxIndex.value - 1].style.left.split('px')[0]//左侧字幕box
            const leftWidth = contentRef.value.getElementsByClassName('itemBox')[boxIndex.value - 1].style.width.split('px')[0]
            contentRef.value.getElementsByClassName('itemBox')[boxIndex.value].style.left = (oldLeft.value * 1 + left * 1) + 'px'
            // console.log(offsetLeft)
            if (offsetLeft < (leftBox * 1 + leftWidth * 1)) {
                contentRef.value.getElementsByClassName('itemBox')[boxIndex.value].style.left = (leftBox * 1 + leftWidth * 1) + 'px'
            }
            else if ((thisWidth * 1 + offsetLeft * 1) > boxWidth.value) {
                contentRef.value.getElementsByClassName('itemBox')[boxIndex.value].style.left = (boxWidth.value * 1 - thisWidth * 1) + 'px'
            } else {
                contentRef.value.getElementsByClassName('itemBox')[boxIndex.value].style.left = (oldLeft.value * 1 + left * 1) + 'px'
            }

        }

        dragUpdateTime('textBox', boxIndex.value)
    } else if (textFunType.value == 'leftLine') {
        let left = e.pageX - xLine.value
        // console.log('偏移量' + left)
        //左侧边框偏移
        // 字幕框偏移
        const offsetLeft = (oldLeft.value * 1 + left * 1)
        contentRef.value.getElementsByClassName('itemBox')[lineIndex.value].style.left = (oldLeft.value * 1 + left * 1) + 'px'
        contentRef.value.getElementsByClassName('itemBox')[lineIndex.value].style.width = (oldWidth.value * 1 + left * -1) + 'px'
        // console.log(lineIndex.value)
        if (lineIndex.value == 0) {

            // console.log('第一'+offsetLeft)
            // console.log('第一'+oldWidth.value*1)
            if (offsetLeft < 0) {
                contentRef.value.getElementsByClassName('itemBox')[lineIndex.value].style.left = 0 + 'px'
                contentRef.value.getElementsByClassName('itemBox')[lineIndex.value].style.width = (oldWidth.value * 1 + oldLeft.value * 1) + 'px'
            } else if ((oldWidth.value * 1 - left) < 10) {
                contentRef.value.getElementsByClassName('itemBox')[lineIndex.value].style.left = (oldLeft.value * 1 + oldWidth.value * 1 - 10) + 'px'
                contentRef.value.getElementsByClassName('itemBox')[lineIndex.value].style.width = 10 + 'px'

            }

        }
        else if (lineIndex.value > 0) {
            // console.log(oldWidth.value * 1 - left)
            const leftBox = contentRef.value.getElementsByClassName('itemBox')[lineIndex.value - 1].style.left.split('px')[0]//左侧字幕box
            const leftWidth = contentRef.value.getElementsByClassName('itemBox')[lineIndex.value - 1].style.width.split('px')[0]
            if ((oldWidth.value * 1 - left) < 10) {
                contentRef.value.getElementsByClassName('itemBox')[lineIndex.value].style.left = (oldLeft.value * 1 + oldWidth.value * 1 - 10) + 'px'
                contentRef.value.getElementsByClassName('itemBox')[lineIndex.value].style.width = 10 + 'px'
            }
            else {
                // console.log(oldLeft.value * 1 + left)
                // console.log(leftBox * 1 + leftWidth * 1)
                if ((oldLeft.value * 1 + left * 1) < (leftBox * 1 + leftWidth * 1)) {
                    contentRef.value.getElementsByClassName('itemBox')[lineIndex.value].style.left = (leftBox * 1 + leftWidth * 1) + 'px'
                    contentRef.value.getElementsByClassName('itemBox')[lineIndex.value].style.width = (oldLeft.value - leftBox * 1 - leftWidth * 1 + oldWidth.value * 1) + 'px'
                }
            }
        }
        dragUpdateTime('leftLine', lineIndex.value)
    } else if (textFunType.value == 'rightLine') {
        let right = e.pageX - xLine.value
        if (lineIndex.value < (textBox.value.length - 1)) {
            const rightBox = contentRef.value.getElementsByClassName('itemBox')[lineIndex.value + 1].style.left.split('px')[0]//右侧字幕box
            if ((oldWidth.value * 1 + right) < 10) {
                contentRef.value.getElementsByClassName('itemBox')[lineIndex.value].style.width = 10 + 'px'
            } else {
                if ((oldLeft.value * 1 + oldWidth.value * 1 + right * 1) >= rightBox * 1) {
                    contentRef.value.getElementsByClassName('itemBox')[lineIndex.value].style.width = (rightBox * 1 - oldLeft.value * 1) + 'px'
                } else {
                    contentRef.value.getElementsByClassName('itemBox')[lineIndex.value].style.width = oldWidth.value * 1 + right + 'px'
                }
            }
        } else if (lineIndex.value == (textBox.value.length - 1)) {
            if ((oldLeft.value * 1 + oldWidth.value * 1 + right * 1) > boxWidth.value * 1) {
                contentRef.value.getElementsByClassName('itemBox')[lineIndex.value].style.width = boxWidth.value * 1 - oldLeft.value * 1 + 'px'
            } else {
                if ((oldWidth.value * 1 + right) < 10) {
                    contentRef.value.getElementsByClassName('itemBox')[lineIndex.value].style.width = 10 + 'px'
                } else {
                    contentRef.value.getElementsByClassName('itemBox')[lineIndex.value].style.width = oldWidth.value * 1 + right + 'px'
                }
            }
        }
        dragUpdateTime('rightLine', lineIndex.value)

    }


}
const stopDrag = (e) => {
    // console.log(e)
    if(textOverOnOff.value){
        mouseupBox('boxMove',e,boxIndex.value)
    }
    
    document.removeEventListener('mousemove', drag)
}
// 鼠标移上
const textOverStyle = {
    borderColor: 'RGBA(255, 255, 255,1)'
}
const leftLineStyle = {
    borderLeft: ' 1px solid #eee'
}
const textOverNum = ref(-1)
const textOverOnOff=ref(false)//判断是否移动
const textOver = (e: any, index: number) => {
    // console.log(index)
    textOverNum.value = index
    boxIndex.value= index
    document.addEventListener('mouseout', mouseoutBox);
    
   

}

const mouseoutBox = () => {
    textOverNum.value = -1
    
    
}
const mouseupBox=(type:string,e: any, index: number)=>{
    if(type=='DataOld'){
        
        if (textFunType.value == 'textBox') {
            emit('waveOldDataText',['textboxMove', index])
        }else if(textFunType.value == 'leftLine'){
            emit('waveOldDataText',['textleftLine', index])
        }else if(textFunType.value == 'rightLine'){
            emit('waveOldDataText',['textrightLine', index])
        }
        
       
    }else if(type=='boxMove'){
        textOverOnOff.value=false
        if (textFunType.value == 'textBox') {
            emit('textBoxMove', ['boxMove',e,index])
        }else if(textFunType.value == 'leftLine'){
            emit('textBoxMove',['textleftLine',e, index])
        }else if(textFunType.value == 'rightLine'){
            emit('textBoxMove',['textrightLine',e, index])
        }
        
    }
    
}

// 线条拖拽
const lineLeftOld = ref('')//拖拽线条历史位置
const lineRightOld = ref('')//拖拽线条历史位置
const xLine = ref(0)//初始化X轴位置
const lineIndex = ref(0)
const oldWidth = ref(0)//字幕框宽度
const downLine = (e: any, index: number, type: string) => {
    console.log(index)
    oldLeft.value = contentRef.value.getElementsByClassName('itemBox')[index].style.left.split('px')[0]
    // console.log('原来字幕框位置' + oldLeft.value)
    oldWidth.value = contentRef.value.getElementsByClassName('itemBox')[index].style.width.split('px')[0]
    textFunType.value = type
    xLine.value = e.pageX
    lineIndex.value = index
    if (type == 'leftLine') {
        lineLeftOld.value = contentRef.value.getElementsByClassName('leftLine')[index].style.left.split('px')[0]
    }
    mouseupBox('DataOld','',index)
    // else if (type == 'rightLine') {
    //     lineRightOld.value = contentRef.value.getElementsByClassName('rightLine')[index].style.right.split('px')[0]
    //     console.log(lineRightOld.value)
    // }

    document.addEventListener('mousemove', drag);
    document.addEventListener('mouseup', stopDrag);
}
// 拖拽线条或者字幕框调整字幕时间
const emit = __emit
const dragUpdateTime = (type: string, index: number) => {

    const toLeft = contentRef.value.getElementsByClassName('itemBox')[index].style.left.split('px')[0]
    const toWidth = contentRef.value.getElementsByClassName('itemBox')[index].style.width.split('px')[0]
    emit('dragtextTime', toLeft * 1, toWidth * 1, index, speedSpeak.value)


}
// 点击时间轴跳转进度条
const toTime = (e: any) => {
    console.log(e.layerX)
    lineToLeft.value = (e.layerX)
    // const timeRun = (e.layerX + timeFloatLeft.value) / 62.5
    const timeRun = (e.layerX + timeFloatLeft.value) / speedSpeak.value
    runLong.value = e.layerX + timeFloatLeft.value
    emit('lnineToTime', timeRun)

}
// 播放完成
const tofinish = ref(false)
const tofinishPlay = () => {
    tofinish.value = true
    emit('finishPlay', 'finish')
}

// 编辑字幕
const updataText = (type: string, index: number, text: string) => {

    if (type == 'cn') {
        textBox.value[index].original.text = text
    } else {
        textBox.value[index].translation.text = text
    }

}

// 字幕向下合并
const mergeText = (index: number) => {
    console.log(textBox.value)
    console.log(index)
    // let widthNew = (textBox.value[index + 1].endTime - textBox.value[index].beginTime) * 62.5 / 1000
    let widthNew = (textBox.value[index + 1].endTime - textBox.value[index].beginTime) * speedSpeak.value / 1000
    textBox.value[index].endTime = textBox.value[index + 1].endTime
    textBox.value[index].original.text = textBox.value[index].original.text + textBox.value[index + 1].original.text
    if(deltranslatShow.value){
        textBox.value[index].translation.text = textBox.value[index].translation.text + textBox.value[index + 1].translation.text
    }
    
    textBox.value[index].textWidth = widthNew
    textBox.value.splice((index + 1), 1)



}
// 字幕拆分
const addText = (index: number) => {
    console.log('字幕拆分')
    const centerTime = Math.floor((textBox.value[index].endTime - textBox.value[index].beginTime) / 2)
    let obj = {
        beginTime: textBox.value[index].beginTime + centerTime,
        endTime: textBox.value[index].endTime,
        floatLefts: textBox.value[index].floatLefts + (textBox.value[index].textWidth) / 2,
        original :{
            text:''
        },
        textWidth: (textBox.value[index].textWidth) / 2,
        // translation: {
        //     text:''
        // },
    }
    
    if(deltranslatShow.value){
        obj.translation={
            text : ""
        }
    }

    textBox.value[index].endTime = (textBox.value[index].beginTime + centerTime)
    textBox.value[index].textWidth = (textBox.value[index].textWidth / 2)
    textBox.value.splice((index + 1), 0, obj)
}
// 字幕删除
const delText = (index: number) => {
    // console.log('字幕删除'+index)
    // console.log(textBox.value)
    // console.log(textBox.value[index])
    textBox.value.splice(index, 1)
}
// 隐藏、显示译文
const translatShow = ref(true)
const hidetranslat = (Show: any) => {
    translatShow.value = Show[0]
}
// 添加翻译
const addtranslat = (dataList: any) => {
    // console.log('添加翻译')
    console.log(dataList)
    textBox.value.forEach((item, index) => {
        if(item.translation==undefined){
            item.translation={}
            item.translation.text = dataList[index].translation.text
        }else{
            item.translation.text = dataList[index].translation.text
        }
        
    })
    translatShow.value = true
    deltranslatShow.value = true
}
// 简繁转化
const textChange = (dataList: any) => {
    textBox.value.forEach((item, index) => {
        item.original.text = dataList[index].original.text
    })

}
// 拖拽时间轴
const elDrak = (leftPx: number, totalTime: number) => {
    // runLong.value = (leftPx * totalTime * 62.5 / 100000)
    runLong.value = (leftPx * totalTime * speedSpeak.value / 100000)
    // console.log('拖拽时间轴' + runLong.value)
    // 容器宽度
    const contentWidth = subtitlesRef.value.offsetWidth
    // 容器倍数
    const num = Math.floor(boxWidth.value / contentWidth)
    // console.log('容器倍数' + num)
    // console.log((boxWidth.value / runLong.value))
    setTimeout(() => {
        if (runLong.value < boxWidth.value && runLong.value < contentWidth * num) {
            // console.log('contentWidth' + contentWidth)
            // console.log('runLong' + runLong.value)
            lineToLeft.value = ((runLong.value % contentWidth))
            // 时间轴偏移
            timeBoxLeft.value = Math.floor(runLong.value / contentWidth) * contentWidth
            // 字幕框偏移
            // console.log(timeBoxLeft.value)
            // 滚动条位置
            scrollbarRef.value!.setScrollLeft(timeBoxLeft.value)
        } else if (runLong.value <= boxWidth.value && runLong.value >= contentWidth * num) {
            if (num <= 1) {
                // 标线偏移量
                lineToLeft.value = runLong.value
                // 时间轴偏移
                timeBoxLeft.value = 0
                // 滚动条位置
                scrollbarRef.value!.setScrollLeft(0)

            } else {
                // 标线偏移量
                lineToLeft.value = (contentWidth * num - (boxWidth.value - contentWidth)) + (runLong.value - contentWidth * num)
                // 时间轴偏移
                timeBoxLeft.value = boxWidth.value - contentWidth
                // 滚动条位置
                scrollbarRef.value!.setScrollLeft(boxWidth.value - contentWidth)
            }
            // // 标线偏移量
            // lineToLeft.value = ((runLong.value - (boxWidth.value - contentWidth)))

            // // 时间轴偏移
            // timeBoxLeft.value = boxWidth.value - contentWidth
            // // 滚动条位置
            // scrollbarRef.value!.setScrollLeft(boxWidth.value - contentWidth)
        }
    }, 100)


}
// 重复播放该字幕
const reTimeout=ref()
const rePlatText = (time: number) => {
    // console.log(time)
    // runLong.value = (time * 62.5 / 1000 - 4)
    clearTimeout(reTimeout.value)
    reTimeout.value=null
    runLong.value = (time * speedSpeak.value / 1000 - 4)
    // console.log(runLong.value)
    // 容器宽度
    const contentWidth = subtitlesRef.value.offsetWidth
    // 容器倍数
    const num = Math.floor(boxWidth.value / contentWidth)
    // console.log('容器倍数' + num)
    // console.log((boxWidth.value / runLong.value))
    reTimeout.value=setTimeout(() => {
        if (runLong.value < boxWidth.value && runLong.value < contentWidth * num) {
            // console.log('contentWidth' + contentWidth)
            // console.log('runLong' + runLong.value)
            lineToLeft.value = ((runLong.value % contentWidth))
            // 时间轴偏移
            timeBoxLeft.value = Math.floor(runLong.value / contentWidth) * contentWidth
            // 字幕框偏移
            // console.log(timeBoxLeft.value)
            // 滚动条位置
            scrollbarRef.value!.setScrollLeft(timeBoxLeft.value)
        } else if (runLong.value <= boxWidth.value && runLong.value >= contentWidth * num) {
            // 标线偏移量
            lineToLeft.value = ((runLong.value - (boxWidth.value - contentWidth)))
            // 时间轴偏移
            timeBoxLeft.value = boxWidth.value - contentWidth
            // 滚动条位置
            scrollbarRef.value!.setScrollLeft(boxWidth.value - contentWidth)
        }
    }, 100)
}
// 退出页面关闭定时器
const clostTime = () => {
    console.log('退出页面关闭定时器')
    clearInterval(setIntervalTime)
    setIntervalTime = null
}
// 撤销删除内容
const revokeaddText=(data:any)=>{
    console.log('撤销删除内容')
    console.log(data)
    
    let obj = {
        beginTime: data.old.beginTime ,
        endTime: data.old.endTime,
        floatLefts:(data.old.beginTime * speedSpeak.value / 1000) ,
        original:{
            text:data.old.original.text
        },
        textWidth: ((data.old.endTime-data.old.beginTime) * speedSpeak.value / 1000),
        // translation:{
        //     text:data.old.translation.text
        // } 
    }
    if(deltranslatShow.value){
        obj['translation'] = { text: data.old.translation.text }
    }
   
    textBox.value.splice((data.index), 0, obj)
    // console.log(textBox.value)
}
// 撤销合并
const MergeTextRevoke=(data:any,index:number)=>{
    console.log("撤销合并")
    console.log(data)
    console.log(index)
    let obj = {
        beginTime: data.beginTime ,
        endTime: data.endTime,
        floatLefts:(data.beginTime * speedSpeak.value / 1000) ,
        original:{
            text:data.original.text
        },
        textWidth: ((data.endTime-data.beginTime) * speedSpeak.value / 1000),
        // translation:{
        //     text:data.translation.text
        // } 
        
    }
    if(deltranslatShow.value){
        obj['translation'] = { text: data.old.translation.text }
    }
   
    textBox.value.splice((index), 0, obj)
    console.log(textBox.value)
}
// 撤销字幕拖拽
const revokeMoveText=(data:any,type:string)=>{
    console.log('======撤销字幕拖拽')
    console.log(data)
    console.log(type)
    if(type=='revoke'){
        textBox.value[data.index].floatLefts=(data.old.beginTime * speedSpeak.value / 1000)
        contentRef.value.getElementsByClassName('itemBox')[data.index].style.left=textBox.value[data.index].floatLefts+'px'
       
    }else{
        textBox.value[data.index].floatLefts=(data.new.beginTime * speedSpeak.value / 1000)
        contentRef.value.getElementsByClassName('itemBox')[data.index].style.left=textBox.value[data.index].floatLefts+'px'
        
    }

}
// 
const revokeMoveLine=(data:any,type:string,lineType:string)=>{
    console.log('======撤销拉伸')
    console.log(data)
    console.log(type)
    if(lineType=='textleftLine'){
        if(type=='revoke'){
            textBox.value[data.index].floatLefts=(data.old.beginTime * speedSpeak.value / 1000)
            textBox.value[data.index].textWidth=((data.old.endTime-data.old.beginTime) * speedSpeak.value / 1000)
            contentRef.value.getElementsByClassName('itemBox')[data.index].style.left=textBox.value[data.index].floatLefts+'px'
            contentRef.value.getElementsByClassName('itemBox')[data.index].style.width=textBox.value[data.index].textWidth+'px'
            console.log(textBox.value[data.index].textWidth)
        }else{
            textBox.value[data.index].floatLefts=(data.new.beginTime * speedSpeak.value / 1000)
            textBox.value[data.index].textWidth=((data.new.endTime-data.new.beginTime) * speedSpeak.value / 1000)
            contentRef.value.getElementsByClassName('itemBox')[data.index].style.left=textBox.value[data.index].floatLefts+'px'
            contentRef.value.getElementsByClassName('itemBox')[data.index].style.width=textBox.value[data.index].textWidth+'px'
        }
    }else{
        if(type=='revoke'){
            textBox.value[data.index].textWidth=((data.old.endTime-data.old.beginTime) * speedSpeak.value / 1000)
            contentRef.value.getElementsByClassName('itemBox')[data.index].style.width=textBox.value[data.index].textWidth+'px'
        }else{
            textBox.value[data.index].textWidth=((data.new.endTime-data.new.beginTime) * speedSpeak.value / 1000)
            contentRef.value.getElementsByClassName('itemBox')[data.index].style.width=textBox.value[data.index].textWidth+'px'
        }
    }

}

__expose({
    updataText,
    mergeText,
    addText,
    delText,
    hidetranslat,
    addtranslat,
    textChange,
    elDrak,
    rePlatText,
    clostTime,
    revokeaddText,
    MergeTextRevoke,
    revokeMoveText,
    revokeMoveLine,
    reText,
})


return (_ctx: any,_cache: any) => {
  const _component_el_slider = _resolveComponent("el-slider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "canvasBox",
        ref_key: "canvasBoxRef",
        ref: canvasBoxRef
      }, [
        _createElementVNode("div", {
          class: "time",
          style: _normalizeStyle({ 'left': timeBoxLeft.value * -1 + 'px' })
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timeCanvasNum.value * 8, (item, index) => {
            return (_openBlock(), _createElementBlock("canvas", {
              id: 'time_line' + index,
              width: "1500",
              height: "30",
              key: index,
              style: _normalizeStyle(index < timeCanvasNum.value ? { 'display': 'block' } : { 'display': 'none' })
            }, null, 12, _hoisted_3))
          }), 128))
        ], 4),
        _createElementVNode("canvas", {
          class: "wave",
          width: boxCanvasWidth.value,
          height: "140",
          id: "wave",
          style: _normalizeStyle({ 'width': boxCanvasWidth.value + 'px' })
        }, null, 12, _hoisted_4),
        _createElementVNode("div", {
          class: "subtitlesBox",
          ref_key: "subtitlesRef",
          ref: subtitlesRef,
          onMousedown: _cache[1] || (_cache[1] = ($event: any) => (toTime($event)))
        }, [
          _createVNode(_unref(ElScrollbar), {
            class: "scrollbar-horizontal",
            onScroll: _cache[0] || (_cache[0] = ($event: any) => (scrollFu($event))),
            always: "",
            ref_key: "scrollbarRef",
            ref: scrollbarRef
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", {
                  class: "content",
                  style: _normalizeStyle({ 'width': boxWidth.value + 'px' }),
                  ref_key: "contentRef",
                  ref: contentRef
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(textBox.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      style: _normalizeStyle({ 'left': item.floatLefts + 'px', 'width': item.textWidth + 'px', 'top': '16px' }),
                      class: "scrollbar-demo-item itemBox",
                      onMouseover: _withModifiers(($event: any) => (textOver($event, index)), ["stop"]),
                      onMousedown: _withModifiers(($event: any) => (textMouse($event, index, 'textBox')), ["stop"])
                    }, [
                      _createElementVNode("div", {
                        class: "leftLine",
                        onMousedown: _withModifiers(($event: any) => (downLine($event, index, 'leftLine')), ["stop"])
                      }, null, 40, _hoisted_7),
                      _createElementVNode("div", {
                        class: _normalizeClass(["textCn", (textrightLine.value&&!isTtsDubbing.value&&(item.ttsAudio!=undefined&&item.ttsAudio.audioDuration>(item.endTime-item.beginTime)))?'textErrBox':'textBox'])
                      }, _toDisplayString(item.original.text), 3),
                      (translatShow.value && deltranslatShow.value)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["textEn textBox", (textrightLine.value&&isTtsDubbing.value&&(item.ttsAudio!=undefined&&item.ttsAudio.audioDuration>(item.endTime-item.beginTime)))?'textErrBox':'textBox'])
                          }, _toDisplayString(item.translation.text), 3))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        class: "rightLine",
                        onMousedown: _withModifiers(($event: any) => (downLine($event, index, 'rightLine')), ["stop"])
                      }, null, 40, _hoisted_8)
                    ], 44, _hoisted_6))
                  }), 128))
                ], 4)
              ])
            ]),
            _: 1
          }, 512)
        ], 544),
        _createElementVNode("div", {
          class: "timeLine",
          style: _normalizeStyle({ 'left': lineToLeft.value - 4 + 'px' }),
          onMousedown: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (linemousedown($event)), ["stop"]))
        }, _cache[4] || (_cache[4] = [
          _createElementVNode("div", { class: "timeBlock" }, [
            _createElementVNode("div", { class: "square" }),
            _createElementVNode("div", { class: "arrow" }),
            _createElementVNode("div", { class: "line" })
          ], -1)
        ]), 36)
      ], 512),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "toolBoxLine" }, null, -1)),
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(pointList, (item, index) => {
              return _createElementVNode("div", {
                key: item,
                class: "toolBoxpoint",
                onClick: ($event: any) => (peakPoint(index, item.blockSize)),
                style: _normalizeStyle(speedLevel.value == index ? peakPointStyle : '')
              }, null, 12, _hoisted_12)
            }), 64))
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_el_slider, {
              modelValue: pointMovevalue.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((pointMovevalue).value = $event)),
              vertical: "",
              height: "130px",
              onInput: pointChange
            }, null, 8, ["modelValue"])
          ])
        ])
      ])
    ])
  ]))
}
}

})